import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"

export enum SmsTransactionStatus {
    WAITING_PAYMENT = "Aguardando pagamento",
    PAID = "Pagamento recebido",
    PENDING_APPROVAL = "Aguardando aprovação",
    APPROVED = "Aprovada",
}

export interface IBuySMSTransaction {
    id: string
    _id: string
    workspaceId: number
    operatorId: number
    operatorName: string
    status: SmsTransactionStatus
    cents: number
    type: string
    events: {
        _id: string
        event: string
        date: string
    }[]
    extraInfo: {
        quantity: number
        pix_qr_code: string
        orderId: string
    }
    updatedAt: string
    createdAt: string
    __v: number
}

export const adminTransactions: IGenericModel<IBuySMSTransaction> = {
    ...generic(endpoints.ADMIN_TRANSACTIONS),
}
